import { render, staticRenderFns } from "./Clap.vue?vue&type=template&id=341c036c&scoped=true&"
import script from "./Clap.vue?vue&type=script&lang=js&"
export * from "./Clap.vue?vue&type=script&lang=js&"
import style0 from "./Clap.vue?vue&type=style&index=0&id=341c036c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341c036c",
  null
  
)

export default component.exports